module.exports = __webpack_public_path__ + "img/weebcon.acc06d71.png";